module.exports = __webpack_public_path__ + "static/media/logo-updox-2018.f9636ecb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/logo-updox-2018.svg
// module id = 982
// module chunks = 0